import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const whatsappUrl = 'https://wa.me/919886332528';

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo">
          <div className="logo-text">
            <span className="logo-title">Dr. Manaz's Physiotherapy & Rehabilitation Clinic</span>
            <span className="logo-subtitle">Miramar, Panjim</span>
          </div>
        </Link>

        <nav className={`nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <Link to="/" className={location.pathname === '/' ? 'active' : ''}>Home</Link>
          <Link to="/services" className={location.pathname.includes('/services') ? 'active' : ''}>Services</Link>
          <Link to="/conditions" className={location.pathname === '/conditions' ? 'active' : ''}>Conditions</Link>
          <Link to="/home-visit-physiotherapy-panjim" className={location.pathname === '/home-visit-physiotherapy-panjim' ? 'active' : ''}>Home Visits</Link>
          <Link to="/our-team" className={location.pathname === '/our-team' ? 'active' : ''}>Our Team</Link>
          <Link to="/equipment" className={location.pathname === '/equipment' ? 'active' : ''}>Equipment</Link>
          <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>Contact</Link>
        </nav>

        <div className="header-actions">
          <a href="tel:9886332528" className="phone-link">
            <Phone size={18} />
            <span>9886332528</span>
          </a>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-book">
            Book Now
          </a>
        </div>

        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu">

          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>);

};

export default Header;